import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import ShopProducts from "../components/products/ShopProducts"; // Component to display products
import Pagination from "../components/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductsBySeller } from "../store/reducers/homeReducer";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { LayoutGrid, LayoutList, Package, Trophy } from "lucide-react";
import ProductDetailsSkeleton from "./ProductDetailsSkeleton";

const StoreDetails = () => {
  const { storeid } = useParams(); // Extract the store ID from the URL
  const { products, totalProducts, parPage, seller } = useSelector(
    (state) => state.home
  );
  console.log(seller)
  const [styles, setStyles] = useState("grid");
  const [sortPrice, setSortPrice] = useState("all");

  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    // Fetch products by seller ID
    dispatch(fetchProductsBySeller({ sellerId: storeid, pageNumber }));
  }, [storeid, pageNumber]);

  if (!seller || !seller.shopInfo) {

    return (
      <>
       <Headers />
       <ProductDetailsSkeleton/>
       <Footer />
      </>
    ) 
}
  return (
    <div>
      <Headers />
      <section 
        style={{
          backgroundImage: `url(${seller.image})`,
          height: "220px",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "left",
      }}
      className="relative"
      >
        <div className="absolute left-0 top-0 w-full h-full bg-[#0000008a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold flex items-center">{seller.shopInfo.shopName}</h2>
            </div>
          </div>
        </div>
      </section>
      <section className="py-10 w-[80%] md:w-[90%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
        <div className="pl-8 md:pl-0 md:w-full w-[100%] text-sm "> 
        <div className="flex flex-wrap gap-2">
            {seller.isTopSeller && (
              <div className="w-max flex justify-center items-center text-black py-[5px] px-4 rounded-full bg-yellow-400 font-semibold text-s">
                Top Seller <Trophy size={18} className="ml-2" />
              </div>
            )}
          </div>
             <h1 className="text-lg font-medium py-4 flex items-center">About store <Package className="ml-2"/></h1>
             <p className="text-muted-foreground whitespace-pre-wrap break-words">{seller.shopInfo.description}</p>
           </div>
      </section>
      <section className="py-5">
        <div className="w-[80%] md:w-[90%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className="w-12/12 md-lg:w-12/12 md:w-full">
            <div className="pl-8 md:pl-0">
              <div className="lg-md:py-10 mb-10 rounded-md flex justify-between items-start">
                <h2 className="text-lg font-medium text-gray-900">
                {totalProducts} Products
                </h2>
                <div className="flex justify-center items-center gap-3">
                  <div className="flex justify-center items-start gap-4 md-lg:hidden">
                    <div
                      onClick={() => setStyles("grid")}
                      className={`p-2 ${
                        styles === "grid" && "bg-gray-200"
                      } text-gray-700 cursor-pointer rounded-sm`}
                    >
                      <LayoutGrid size={18} />
                    </div>
                    <div
                      onClick={() => setStyles("list")}
                      className={`p-2 ${
                        styles === "list" && "bg-gray-200"
                      } text-gray-700 cursor-pointer rounded-sm`}
                    >
                      <LayoutList size={18} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="pb-8">
                <ShopProducts products={products} styles={styles} />
              </div>
              <div>
                {totalProducts > parPage && (
                  <Pagination
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                    totalItem={totalProducts}
                    parPage={parPage}
                    showItem={Math.ceil(totalProducts / parPage)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <Footer />
    </div>
  );
};

export default StoreDetails;
